@if (!loadingPosts) {
  <div class="blog-container">
    <div class="blog-heading">
      {{ 'blog.heading' | translate }}
    </div>
    <div class="blog-description">
      {{ 'blog.description' | translate }}
    </div>
    <div class="previews-container previews-container--phone">
      <div class="phone-title phone-featured-title">
        {{ 'blog.featured' | translate }}
      </div>
      <div class="phone-articles">
        @for (article of articlePreviews; track article; let i = $index) {
          @if (i < 3) {
            <div class="articles-preview-container">
              <libero-blog-article-ui-preview
                [articlePreview]="article"
                (click)="openDetail(article.blogId)"
                data-cy="phone-top-article"
              ></libero-blog-article-ui-preview>
            </div>
          }
        }
      </div>
    </div>
    @if (page === 1 && articlePreviews.length > 0) {
      <div class="previews-container previews-container--desktop" data-cy="top-articles-section">
        <div class="desktop-newest-article-container">
          <libero-desktop-newest-blog-article-preview
            [articlePreview]="articlePreviews[0]"
            (click)="openDetail(articlePreviews[0].blogId)"
            data-cy="main-top-article"
          ></libero-desktop-newest-blog-article-preview>
        </div>
        <div class="desktop-articles-container">
          @for (article of articlePreviews; track article; let i = $index) {
            @if (i > 0 && i < desktopSecondaryArticlesMaxIndex) {
              <div class="desktop-article">
                <libero-blog-article-ui-preview
                  [articlePreview]="article"
                  (click)="openDetail(article.blogId)"
                  data-cy="secondary-top-article"
                ></libero-blog-article-ui-preview>
              </div>
            }
          }
        </div>
      </div>
    } @else if (!articlePreviews.length) {
      <div class="no-data-container" data-cy="no-posts-message">
        {{ 'global.error.noPosts' | translate }}
      </div>
    }
    @if (articlePreviews.length > 3) {
      <div class="rounded-corner-bg">
        <div class="rounded-corner"></div>
      </div>
    }
  </div>
} @else {
  <libero-preload-spinner></libero-preload-spinner>
}

@if (articlePreviews.length) {
  <div class="older-articles-background" data-cy="older-articles-section">
    <div class="older-articles-header">
      {{ (page === 1 ? 'blog.olderArticles' : 'blog.searchAction') | translate }}
    </div>
    <div class="phone-title older-articles-header--phone">
      {{ 'blog.olderArticles' | translate }}
    </div>
    <div class="blog-search">
      <input type="text" class="form-control" [formControl]="searchFormControl" data-cy="blog-search-input">
      @if (!searchMode) {
        <svg-icon data-cy="search-icon-mglass" src="assets/icons/magnifying-glass.svg" [svgStyle]="{ 'width.px':24, 'height.px':24 }" svgClass="search-icon"></svg-icon>
      }
      @if (searchMode) {
        <svg-icon data-cy="search-icon-cross" src="assets/icons/cross.svg" [svgStyle]="{ 'width.px':24, 'height.px':24 }" svgClass="search-icon" (click)="resetSearch()"></svg-icon>
      }
    </div>
    <div class="blog-container older-articles-container--desktop" data-cy="older-articles-desktop">
      <!-- Older posts from page (desktop) -->
      @if (!searchMode) {
        @for (article of articlePreviews; track article; let i = $index) {
          @if (page !== 1 || i >= 4) {
            <div class="common-device-article" data-cy="desktop-older-posts-container">
              <libero-blog-article-ui-preview
                [articlePreview]="article"
                (click)="openDetail(article.blogId)"
                data-cy="desktop-older-post"
              ></libero-blog-article-ui-preview>
            </div>
          }
        }
      }
      <!-- Searched posts results -->
      <ng-template
        [ngTemplateOutlet]="searchPostResults"
        [ngTemplateOutletContext]="{device: 'desktop'}"
      ></ng-template>
    </div>
    <div class="blog-container older-articles-container--phone" data-cy="older-articles-phone">
      <!-- Older posts from page (phone) -->
      @if (!searchMode) {
        @for (article of articlePreviews; track article; let i = $index) {
          @if (i >= startPhoneOlderArticlesFromIndex) {
            <div class="common-device-article" data-cy="phone-older-posts-container">
              <libero-blog-article-ui-preview
                [articlePreview]="article"
                (click)="openDetail(article.blogId)"
                data-cy="phone-older-post"
              ></libero-blog-article-ui-preview>
            </div>
          }
        }
      }
      <!-- Searched posts results -->
      <ng-template
        [ngTemplateOutlet]="searchPostResults"
        [ngTemplateOutletContext]="{device: 'phone'}"
      ></ng-template>
    </div>
    <ng-template #searchPostResults let-device="device">
      @if (searchMode) {
        @if (searchedPosts.length) {
          @for (article of searchedPosts; track article; let i = $index) {
            <div class="common-device-article">
              <libero-blog-article-ui-preview
                [articlePreview]="article"
                (click)="openDetail(article.blogId)"
                [attr.data-cy]="device + '-searched-post'"
              ></libero-blog-article-ui-preview>
            </div>
          }
        } @else {
          <h3 data-cy="no-search-result">{{ 'blog.noSearchResult' | translate }}</h3>
        }
      }
    </ng-template>
    <div class="desktop-pagination">
      @if (!searchMode && articlesTotal) {
        <libero-blog-pagination
          [articlesTotal]="articlesTotal"
          [articlesSizePerPage]="10"
          (paginationBtnClick)="goToPageDesktop($event)"
          [activePage]="page"
          data-cy="blog-pagination"
        ></libero-blog-pagination>
      }
    </div>
    <div class="phone-pagination">
      @if (!searchMode && articlesTotal && allowLoadMore) {
        <libero-button
          label="{{ 'blog.loadMore' | translate }}"
          btnClasses="btn--primary btn--heading"
          (click)="loadMoreForPhone()"
          [preloader]="loadingPosts"
          data-cy="blog-phone-pagination-btn"
        ></libero-button>
      }
    </div>
  </div>
}

